import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";
import { ImportResponse, ldImportSchemaType } from "@reflag/shared/importAPI";

export function useLaunchDarklyImportMutation() {
  const { app } = useEnvironment();

  return useMutation<
    ImportResponse,
    AxiosError<ErrorResponse>,
    ldImportSchemaType
  >({
    mutationFn: (data) =>
      api
        .post<"/apps/:appId/import/launchdarkly">(
          `/apps/${app.id}/import/launchdarkly`,
          data,
        )
        .then((res) => res.data),
  });
}
